<div class="px-2">
  <p class="title-cart">{{ "cart" | translate }}</p>
  <p class="desc-cart">
    {{ "review-cart" | translate }}
  </p>
  <div *ngFor="let item of ticketService?.bookTicket?.getValue()?.items">
    <app-cart-item [item]="item"></app-cart-item>
  </div>
</div>
